import { getCsrfToken } from 'helpers/csrf';

export const BLOCK_CARD_BEGIN = 'BLOCK_CARD_BEGIN';
export const BLOCK_CARD_SUCCESS = 'BLOCK_CARD_SUCCESS';
export const BLOCK_CARD_FAILURE = 'BLOCK_CARD_FAILURE';

export const UNBLOCK_CARD_BEGIN = 'UNBLOCK_CARD_BEGIN';
export const UNBLOCK_CARD_SUCCESS = 'UNBLOCK_CARD_SUCCESS';
export const UNBLOCK_CARD_FAILURE = 'UNBLOCK_CARD_FAILURE';

const fetchBlockCardSuccess = (data) => ({
  type: BLOCK_CARD_SUCCESS,
  payload: data,
});

const fetchBlockCardBegin = () => ({
  type: BLOCK_CARD_BEGIN,
});

const fetchBlockCardFailure = (error) => ({
  type: BLOCK_CARD_FAILURE,
  error
});

const fetchUnblockCardSuccess = (data) => ({
  type: UNBLOCK_CARD_SUCCESS,
  payload: data,
});

const fetchUnblockCardBegin = () => ({
  type: UNBLOCK_CARD_BEGIN,
});

const fetchUnblockCardFailure = (error) => ({
  type: UNBLOCK_CARD_FAILURE,
  error
});

export const fetchBlockCard = (cardNumber) => async (dispatch) => {
  dispatch(fetchBlockCardBegin());

  const token = await getCsrfToken();

  return fetch(`/api/cards/${cardNumber}/block`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'x-csrf-token': token,
      },
      body: JSON.stringify({}),
    })
    .then(response => handleErrors(response))
    .then(data => dispatch(fetchBlockCardSuccess(data)))
    .catch(err => dispatch(fetchBlockCardFailure(err.message)));
}

export const fetchUnblockCard = (cardNumber) => async (dispatch) => {
  dispatch(fetchUnblockCardBegin());

  const token = await getCsrfToken();

  return fetch(`/api/cards/${cardNumber}/unblock`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'x-csrf-token': token,
      },
      body: JSON.stringify({}),
    })
    .then(response => handleErrors(response))
    .then(data => dispatch(fetchUnblockCardSuccess(data)))
    .catch(err => dispatch(fetchUnblockCardFailure(err.message)));
}

function handleErrors(response) {
  if (!response.ok) {
    return response.json().then(errorResponse => {
      let msg;
      if (errorResponse.extraParameters && Array.isArray(errorResponse.extraParameters.json)) {
        msg = errorResponse.extraParameters.json[0];
      }
      if (response.status === 404) {
        throw new Error(msg || errorResponse.detail || 'Deze pas werd niet gevonden.');
      } else if (response.status === 403) {
        throw new Error(msg || 'U heeft geen toegang.');
      } else {
        throw new Error(msg || 'Er is een fout opgetreden.');
      }
    }).catch(err => {
      throw err;
    });
  }
  return response.json();
}
